import {
    UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS,
    UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED,
    RESET_UPDATEMODULEALLOCATIONLISTFORADMIN,
    LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN,
    NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_UPDATEMODULEALLOCATIONLISTFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
